module.exports = __webpack_public_path__ + "band_10.d94c0514.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_10.png
// module id = q+iV
// module chunks = 0